import { Card } from "antd";
import React from "react";
import { maskNumbersExceptLastFour } from "utils";

interface CardDetails {
  AccountName: string;
  AccountNickName: string;
  AccountRoutingNumber: string;
  AccountNumber: string;
  accountType: string;
  updatedDate: string;
  createdDate: string;
}

export function AchInfoCard(props: CardDetails) {

  return (
    <Card className="items-stretch max-w-fit max-h-fit bg-cover">
      <div className="text-lg font-bold text-black !mb-4">
        Account Details
      </div>
      <div className="mb-4 grid grid-flow-col grid-cols-1">
        <div className="flex flex-col">
          <label className="text-sm font-semibold text-gray-500">
            ACCOUNT NUMBER
          </label>
          <input
            className="flex h-10 w-full items-center justify-center rounded-lg border-gray-900
                              bg-inputBgNotFocus p-3 text-sm text-gray-500 outline-none
                              focus:border-primary-700 focus:bg-gray-50 focus:outline-none "
            value={props?.AccountNumber && maskNumbersExceptLastFour(props?.AccountNumber)}
            readOnly
          ></input>
        </div>
      </div>
      <div className="mb-4 grid grid-flow-col grid-cols-1">
        <div className="flex flex-col">
          <label className="text-sm font-semibold text-gray-500">
            ROUTING NUMBER
          </label>
          <input
            className="flex h-10 w-full items-center justify-center rounded-lg border-gray-900
                              bg-inputBgNotFocus p-3 text-sm text-gray-500 outline-none
                              focus:border-primary-700 focus:bg-gray-50 focus:outline-none "
            value={props?.AccountRoutingNumber && maskNumbersExceptLastFour(
              props?.AccountRoutingNumber
            )}
            readOnly
          ></input>
        </div>
      </div>
      <div className="mb-4 grid grid-flow-col grid-cols-1">
        <div className="flex flex-col">
          <label className="text-sm font-semibold text-gray-500">
            ACCOUNT TYPE
          </label>
          <input
            className="flex h-10 w-full items-center justify-center rounded-lg border-gray-900
                              bg-inputBgNotFocus p-3 text-sm text-gray-500 outline-none
                              focus:border-primary-700 focus:bg-gray-50 focus:outline-none "
            value={props?.accountType}
            readOnly
          ></input>
        </div>
      </div>
    </Card>
  )
}